import Common from '../../Common';
import Field from './commoncontact/Field';

const CommonContact = class extends Common {
	field: InstanceType<typeof Field>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.field = new Field(headers);
	}

	async browse(userId: id) {
		return this.get(`/user/${userId}/commoncontacts`)
	}

	async read(userId: id, contactId: id) {
		return this.get(`/user/${userId}/commoncontacts/${contactId}`)
	}

	async delete(userId: id, contactId: id) {
		return this.doDelete(`/user/${userId}/commoncontacts/${contactId}`)
	}
}

export default CommonContact;
